import * as login from './login'

// 统一导出所有模块的接口
export default {
  login,
}
